<svg
  width="21"
  height="20"
  viewBox="0 0 21 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.5003 6.66675V10.0001M10.5003 13.3334H10.5087M18.8337 10.0001C18.8337 14.6025 15.1027 18.3334 10.5003 18.3334C5.89795 18.3334 2.16699 14.6025 2.16699 10.0001C2.16699 5.39771 5.89795 1.66675 10.5003 1.66675C15.1027 1.66675 18.8337 5.39771 18.8337 10.0001Z"
    stroke="#F04738"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
